import { useDispatch, useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { useTranslation } from "react-i18next";
import { Button, Card, Col, Form, InputGroup, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";

import "../../Assets/scss/pages/settings.scss";
import NoRecordFound from "../../Components/NoRecordFound";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AddFilterContentService, deleteFilterContentService, getFilterContentService, UpdateFilterContentService } from "../../Services/FilterContentService";

interface PropTypes {
    disabledButton: boolean
}

// component to render settings page
const FilterContentPage = (prop: PropTypes) => {
  // Redux Data
  const { accessToken, currentWebsite, currentUserStatus } = useSelector(
    (store: StoreProptypes) => store
  );

  const { disabledButton } = prop;

  // Functions
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // useState
  const [filterContentListData, setFilterContentListData] = useState<any>();
  const location = useLocation();
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    if (accessToken && currentWebsite) {
      // service to get card list
      getFilterContentService(accessToken, currentWebsite?.id?.toString(), setFilterContentListData, dispatch, t);
    }
  }, [accessToken, currentWebsite]);

  // Show Card Popup
  const [filterContentLandMark, setFilterContentLandMark] = useState("");
  const [editingfilterContentLandMark, setEditingFilterContentLandMark] = useState<any | null>(null);
  const [showFilterContentPopup, setShowFilterContentPopup] = useState(false);
  const [showDeleteFilterContentPopup, setDeleteFilterContentPopup] = useState(false);
  const [deleteFilterContentID, setDeleteFilterContentID] = useState<number | null>();

  // function to close Voice command popup
  const handleCloseFilterContentPopup = () => {
    setShowFilterContentPopup(false);
    resetVoiceCommandForm()
  };

  // function to show Voice Command popup
  const handleShowFilterContentPopup = () => {
    setShowFilterContentPopup(true);
  };

   // function to display delete card popup
  const handleShowDeleteFilterContentPopup = (id: number) => {
    setDeleteFilterContentPopup(true);
    id && setDeleteFilterContentID(id);
  };

  const validateLandMarkCommand = () => {
    const newErrors: { [key: string]: string } = {};

    if (!filterContentLandMark.trim()) {
      newErrors.filterContentLandMark = t("Land mark is required");
    } else if (filterContentLandMark.length > 100) {
      newErrors.filterContentLandMark = t("Land mark cannot exceed 100 characters");
    }
    

    setErrors(newErrors);
    console.log('newErrors: ', newErrors);

    return Object.keys(newErrors).length === 0;
  };

   const resetVoiceCommandForm = () => {
    setFilterContentLandMark("");
    setEditingFilterContentLandMark(null); // exit edit mode
    setErrors({});
  };


  const handleEditFilterContentLandMark = (id: number) => {
    const getSelectedIdData = filterContentListData.find((d:any) => d.id === id)
    if (getSelectedIdData) {
      setFilterContentLandMark(getSelectedIdData?.title)
      setEditingFilterContentLandMark(getSelectedIdData)
      handleShowFilterContentPopup()
    }
  }

  const saveLandMarkCommand = (e: React.FormEvent) => {
    e.preventDefault();
    if (accessToken && (validateLandMarkCommand()) && currentWebsite) {
      if (editingfilterContentLandMark) {
        UpdateFilterContentService(editingfilterContentLandMark.id, currentWebsite?.id?.toString(), filterContentLandMark, accessToken,setFilterContentListData, setShowFilterContentPopup,  dispatch, t, resetVoiceCommandForm)
      } else {
        AddFilterContentService(currentWebsite?.id?.toString(), filterContentLandMark, accessToken, setFilterContentListData, setShowFilterContentPopup,  dispatch, t, resetVoiceCommandForm)
      }
    }
  }

    // function to close card delete popup
  const handleCloseDeleteFilterContemtPopup = () => {
    setDeleteFilterContentPopup(false);
    setDeleteFilterContentID(null);
  };

  // function to handle delete card
  const handleDeleteFilterContent = () => {
    // check if access token and delete card ID are available
    if (accessToken && deleteFilterContentID && currentWebsite) {
      // service to perform delete card
      deleteFilterContentService(
        accessToken,
        currentWebsite?.id?.toString(),
        deleteFilterContentID,
        setFilterContentListData,
        setDeleteFilterContentPopup,
        dispatch,
        t
      );
    }
  };

   const renderTooltip = (props:any) => (
    <Tooltip id="button-tooltip" {...props}>
      Include HTML tags so that all elements on the page wrapped with these tags will appear in the filter content popup
    </Tooltip>
  );

  return (
    <>
        <div className="manage-cards">
            <Card className="mt-3">
                <Card.Header>
                <h2 className="mb-0 h5">{t("Filter Content Custom Land Mark")}</h2>
                <Button
                    variant="primary"
                    disabled={disabledButton}
                    onClick={handleShowFilterContentPopup}
                    size="lg"
                    className="aioa_dashboard-icon-btn"
                >
                    <div className="aioa_dashboard-btn-icon">
                    <i
                        className="material-symbols-outlined"
                        aria-hidden="true"
                    >
                        add_home
                    </i>
                    </div>
                    <div className="aioa_dashboard-btn-text">
                    {t("Add Land Mark")}
                    </div>
                </Button>
                </Card.Header>

                <Card.Body>
                <div className="credit-card-list">
                    {filterContentListData ? (
                    <>
                        {filterContentListData.length > 0 ? (
                        <>
                            <Row xl={2}>
                            {filterContentListData.map((item:any) => {
                                return (
                                <Col key={item.id}>
                                    <div
                                    className={`credit-card-box`}
                                    >
                                    <div
                                        className={`credit-card-details`}
                                    >
                                        <div className="credit-card-detail-box">
                                        <span>
                                            <strong className="ellipsis">
                                            {item.title}
                                            </strong>
                                        </span>
                                        </div>
                                    </div>

                                    <div className="action-btns">
                                        <Button
                                            variant="primary"
                                            className="ms-3"
                                            disabled={disabledButton}
                                            aria-label={t(
                                            "Edit Billing Address"
                                            ).toString()}
                                            onClick={() =>
                                            handleEditFilterContentLandMark(
                                                item.id
                                            )
                                            }
                                        >
                                            <i
                                            className={`material-symbols-outlined`}
                                            aria-hidden="true"
                                            >
                                            edit
                                            </i>
                                        </Button>

                                        <Button
                                            variant="danger"
                                            aria-label={t(
                                            "Delete Billing Address"
                                            ).toString()}
                                            disabled={disabledButton}
                                            onClick={() =>
                                            handleShowDeleteFilterContentPopup(
                                                item.id
                                            )
                                            }
                                        >
                                            <i
                                            className={`material-symbols-outlined`}
                                            aria-hidden="true"
                                            >
                                            delete
                                            </i>
                                        </Button>
                                        </div>
                                    </div>
                                </Col>
                                );
                            })}
                            </Row>
                        </>
                        ) : (
                        <>
                            <div className="w-100">
                            <NoRecordFound
                                imageType={`card`}
                                joyful={false}
                                noRecordText={`No Custom Land Mark.`}
                            />
                            </div>
                        </>
                        )}
                    </>
                    ) : (
                    <></>
                    )}
                </div>
                </Card.Body>
            </Card>
        </div>
      <Modal
        show={showFilterContentPopup}
        onHide={handleCloseFilterContentPopup}
        size="lg"
        fullscreen="lg-down"
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          {editingfilterContentLandMark ?
          <Modal.Title>{t("Update Land Mark")}</Modal.Title>
          :
          <Modal.Title>{t("Add Land Mark")}</Modal.Title>
          }
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={saveLandMarkCommand}>
           <div className='card-input-group row'>
                <div className='col-12'>
                    <h5 className="d-flex gap-1">
                        {t("Land Mark")}
                        <OverlayTrigger
                          placement="right"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderTooltip}
                        >
                          <i className="material-symbols-outlined" aria-hidden="true">info</i>
                        </OverlayTrigger>
                    </h5>
                  <InputGroup className="mt-3 input-group-outline">
                    <Form.Control
                      placeholder={`${t("Enter Land Mark")}`}
                      aria-label={`${t("Title")}`}
                      type="text"
                      className="rounded-2"
                      size="lg"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterContentLandMark(e.target.value)}
                      value={filterContentLandMark}
                      isInvalid={!!errors.filterContentLandMark}
                      style={{ backgroundImage: "none", paddingRight: "0.75rem" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.filterContentLandMark}
                    </Form.Control.Feedback>
                  </InputGroup>

                </div>
            </div>
            <div className='card-save-btns d-flex m-2 justify-content-center'>
                <Button variant="primary" type="submit">
                    {/* {showCardPopupLoading ? <Spinner animation="grow" size='sm' className='me-2' /> : <></>} */}
                    {editingfilterContentLandMark ?
                      <span>
                          {t('Update')}
                      </span>
                     :
                      <span>
                          {t('Save Button Label')}
                      </span>
                     }
                </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        show={showDeleteFilterContentPopup}
        onHide={handleCloseDeleteFilterContemtPopup}
        size="lg"
        fullscreen="lg-down"
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Delete Filter Land Mark")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("Are you sure want to delete Land Mark?")}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleDeleteFilterContent}>
            {t("Delete Button Label")}
          </Button>
          <Button variant="danger" onClick={handleCloseDeleteFilterContemtPopup}>
            {t("Close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FilterContentPage;
